export const DefaultSettings ={
    notifications_enabled: false,
    settings_enabled: false,
    calendar_enabled: false,
    tutorial_enabled: true,
    billing_enabled: true,
}